import { makeHook } from "../../utils/makeSingleArgHook";
import getTasksBatch from "../requests/getTasksBatch";
import { tasksUrl } from "../requests/urls";
export function tasksBatchKeyMaker(request) {
    return [
        tasksUrl("v3_1"),
        JSON.stringify({
            filterByTaskIds: request.taskIds,
            filterByAdvisor: request.advisorId,
        }),
    ];
}
const useGetTasksBatch = makeHook(async (request, auth) => getTasksBatch(auth, request), tasksBatchKeyMaker);
export default useGetTasksBatch;
//# sourceMappingURL=useGetTasksBatch.js.map